export const m = {
  EnterID: "クリックしてTada IDを入力します",
  "select-specifications": "クリックしてチャージ種類を選択します",
  "check-account": "リチャージアカウントを確認します",
  whatID: "Tada ID とは？",
  getID: "Tada ID を入力します",
  maskgetID: "Tada ID を入力します",
  "toastTips-format-error": "入力フォーマットが正しくありません",
  "toastTips-no-exist": "ID は存在しません",
  toastTipsPlease: "まずはリチャージアカウントを確認してください",
  "common-problem": "よくある問題",
  "transaction-succeeded": "取引成功",
  "transaction-failed": "取引失敗",
  "transaction-cancel": "取引キャンセル",
  "whether-account": "1.チャージ後どのように入金を確認しますか?",
  "answer-whether-account":
    "チャージ後、appの[マイ]-[ウォレット]に戻ってダイヤモンドを確認してください",
  "no-account": "2.チャージ後に入金していない場合はどうすればいいですか?",
  "answer-no-account":
    '"アプリの【メッセージ】-【公式ニュース】-【フィードバックとヘルプ】で質問を送信して、以下の情報を提供してください。その時カスタマーサービスがお手伝いします。"',
  "recharge-money": "1.チャージ金額とアカウントID",
  "recharge-time": "2.チャージ時間と日付",
  "recharge-shot": "3.支払い成功のスクリーンショット",
  "recharge-wrong": "3.アカウントと金額を間違った場合はどうすればいいですか",
  "answer-recharge-wrong":
    "決済パスワードを入力する前に、チャージアカウントのIDとチャージ金額情報をよくご確認の上、ご購入ください。金額を間違えてチャージする場合は返金できません。間違ったアカウントにチャージする場合は、実際にチャージしたIDユーザーに連絡して、相手とあなたにチャージ金額を補償するかどうか交渉してみてください。。",
  refund: "4.返金",
  "answer-refund":
    "すみません！Tadaは現在、いかなる形の返金にも対応していません。",
  "buy-enter-link":
    'ダイヤモンドを購入してリンクを通じてチャージできます。<a class="web-link" href="https://pay.tadachat.info/" >https://pay.tadachat.info</a> リンクをコピーしてスマホのブラウザーで開き、購入ページに入り、アカウントを確認し、相応のチャージ種類を選択し、適切な支払い方法で支払います〜　たくさんの割引がありますよ！',
  "buy-notice-a":
    "注意：<a>pay.tadachat.info</a> はTadaの唯一の公式ダイヤモンド購入サイトです",
  replace: "変更",
  sureBtn: " OK ",
  "pay-style": "支払い方法を選択してください",
  goBack: "ホームページに戻る",
  toastTips: "Tada ID を入力します",
  rechargeFAQ_title: "よくある問題",
  PayStatusSuccess_title: "取引成功",
  PayStatusFail_title: "取引失敗",
  PayStatusCancel_title: "取引キャンセル",
  Diamonds_title: "Tadaダイヤモンドリチャージ公式サイト",
  "buy-notice":
    "注: pay.Tadachat.info は Tada の唯一の公式購入ダイヤモンド サイトであり、カスタマー サービスに関する問い合わせは[メッセージ] - [公式メッセージ] - [フィードバックとヘルプ]",
  RechargeHelp_title: "リチャージヘルプ",
  openAPP: "Tadaアプリを開く",
  "buy-diamonds-tit": "ダイヤモンドサービスの購入",
  description:
    "Tadaは唯一の公式ダイヤモンドチャージサイトです。Tadaは、世界150カ国以上と地域のユーザーが利用している国際的なソーシャルソフトウェアです。",
  keywords:
    "Tadaチャージ、Tadaダイヤモンドチャージ、Tada公式チャージ、Tada公式チャージウェブサイト",
  payforType: " 充電方法",
  trueText: "OK",
  falseText: "キャンセル",
  alertShowTxt1: "",
  alertShowTxt3: "",
  alertShowTxt5: "を使用して%sダイヤモンドを再充電してもよろしいですか？",
  EnterIDTip: "Tadaクイックリチャージ",
  scanLogin:
    "アカウントのプライバシーとセキュリティのために、コードをスキャンしてログインしてください",
  scanTip:
    "ヒント：Tadaの「パーソナルセンター/ダイナミクス」の右上隅にある「スキャン」をクリックして、コードをスキャンしてログインします。同時に、QRコードのスクリーンショットを識別してログインをサポートします。",
  scanVersion:
    "Tadaを％sバージョンにアップグレードし、コードをスキャンしてログインしてください",
  delAccount: "アカウントの削除",
  logout: "ログアウト",
  submit: "提出",
  email_place_holder: "メールボックスを入力してください",
  contact_email: "連絡先メールアドレス",
  provide_email: "支払い通知を受け取るためのメールアドレスを入力してください",
  email_address: "電子メールアドレス",
};



// WEBPACK FOOTER //
// ./src/lang/ja.js